export default function registerStartRecord($, apower) {
  //start recording button for online screen recorder, online audio recorder
  $.registerOnce(
    ".sub-start-recording, .sub-select-files, .sub-screenshot-launch",
    function () {
      this.el.$on("click", function () {
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          300
        );

        if (apower.productId == 37 && window.audioRecorder) {
          if (window.audioRecorder.isRecording) {
            window.audioRecorder.endRecording();
            return;
          } else if (window.audioRecorder.opened) {
            return;
          }
        }

        $(
          ".main .start-recording, .main .start-video-converter, .main .screenshot-launch"
        ).click();
      });
    }
  );
}
